const onAttributeChange = (node: (Element | null), fn: Function) => {
  // Options for the observer (which mutations to observe)
  const config = { attributes: true }

  // Callback function to execute when mutations are observed
  const callback = function (mutationsList: any) {
    // Use traditional 'for loops' for IE 11
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes') {
        if (node) {
          fn()
        }
      }
    }
  }

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback)

  if (node) {
    // Start observing the target node for configured mutations
    observer.observe(node, config)
  }
}

export default onAttributeChange
